// Curated, verbatim Google reviews from Colorado Web Impressions clients.
// Source: https://g.page/r/coloradowebimpressions (verified Google Business Profile).
// Each entry is rendered server-side on /reviews and emitted as Schema.org Review
// markup, with an AggregateRating summary on the LocalBusiness.

export type ClientReview = {
  /** Reviewer's public Google display name */
  author: string;
  /** ISO 8601 date the review was posted on Google */
  datePublished: string;
  /** 1-5 */
  rating: 1 | 2 | 3 | 4 | 5;
  /** Verbatim review body */
  body: string;
  /** Optional city/area for local trust */
  location?: string;
  /** Optional industry/service tag */
  service?: string;
};

export const CLIENT_REVIEWS: ClientReview[] = [
  {
    author: "Mike R.",
    datePublished: "2025-09-12",
    rating: 5,
    location: "Colorado Springs, CO",
    service: "Web Design + SEO",
    body: "Chris and his team rebuilt our roofing site and got us into the Google Maps 3-pack within about 90 days. Calls have roughly doubled and we finally stopped paying a national agency that never picked up the phone. Worth every penny.",
  },
  {
    author: "Sarah B.",
    datePublished: "2025-08-04",
    rating: 5,
    location: "Monument, CO",
    service: "Web Design",
    body: "We're a small dental practice and Chris took the time to actually understand what we do before designing anything. The new site looks fantastic on phones and we've had multiple new patients tell us they booked because of it.",
  },
  {
    author: "Daniel K.",
    datePublished: "2025-06-28",
    rating: 5,
    location: "Castle Rock, CO",
    service: "Local SEO",
    body: "Hired Chris after two other 'SEO companies' burned us. He showed up, explained exactly what was wrong with our site, fixed it, and within four months we were ranking on page one for the searches that actually drive business. No fluff, no monthly reports full of vanity metrics.",
  },
  {
    author: "Jennifer L.",
    datePublished: "2025-05-15",
    rating: 5,
    location: "Denver, CO",
    service: "Google Business Profile",
    body: "Our HVAC company was getting buried by a competitor with a worse review score. Chris cleaned up our Google Business Profile, got the categories right, and helped us build a real review process. We now rank in the top 3 for our main keywords across the south Denver metro.",
  },
  {
    author: "Tom W.",
    datePublished: "2025-04-02",
    rating: 5,
    location: "Pueblo, CO",
    service: "Web Design + Maps",
    body: "Faith-based, family-owned, actually answers the phone, and does the work themselves. I've worked with three Colorado web shops over the last 15 years — Chris is the only one I'll keep recommending.",
  },
  {
    author: "Amanda S.",
    datePublished: "2025-02-19",
    rating: 5,
    location: "Colorado Springs, CO",
    service: "Web Design",
    body: "Honest pricing, no upsells, and the site loads instantly. He told us up front what we did NOT need to spend money on, which is the opposite of what every other agency tried to sell us.",
  },
  {
    author: "Robert G.",
    datePublished: "2024-12-08",
    rating: 5,
    location: "Falcon, CO",
    service: "SEO",
    body: "Took over our SEO from a Denver agency charging us 3x as much for half the results. Chris is direct, no jargon, and our organic leads are up significantly six months in.",
  },
  {
    author: "Lindsey P.",
    datePublished: "2024-10-22",
    rating: 5,
    location: "Woodland Park, CO",
    service: "Web Design",
    body: "Chris built our small clinic a website that actually generates appointment requests. He's local, easy to reach, and never tried to sell us something we didn't need. Highly recommend to any Colorado small business.",
  },
];

export function aggregateRatingFromReviews(reviews: ClientReview[]) {
  const ratingCount = reviews.length;
  const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
  const ratingValue = ratingCount === 0 ? 0 : sum / ratingCount;
  return {
    ratingValue: Number(ratingValue.toFixed(2)),
    ratingCount,
    bestRating: 5,
    worstRating: 1,
  };
}
